module.exports = __webpack_public_path__ + "img/gPay-Support.7fda3790.svg";